import { castResponse } from "@utils/hooks/useTypedRequest";
import { PostRequest } from "./http/BaseRequest";
import { RecordsResponse } from "./http/responses/BaseResponse";
import W2UiFilterBuilder from "./w2ui";
import { SortItem } from "./w2ui/w2const";

export interface UserTabInfo {
  id: number;
  userid: number;
  name: string;
}

export const listTabsRequest = {
  makeRequest() {
    const builder = new W2UiFilterBuilder();
    builder.setSort([SortItem.asc("id")]);
    return new PostRequest("/user/vtabs/w2ui", builder.build().stringParams);
  },
  makeResponse: castResponse<RecordsResponse<UserTabInfo>>,
};

export const createTabRequest = {
  makeRequest(name: string) {
    const builder = new W2UiFilterBuilder();
    builder.setEdit({recid: "new", name});
    return new PostRequest("/user/vtabs/w2ui", builder.build().stringParams);
  },
  makeResponse: castResponse<RecordsResponse<number>>,
};

export const moveMinerToUserTabRequest = {
  makeRequest(id: number, minerIDs: string[], move = false) {
    const params = {
      action: move ? "set" : "remove",
      minerid: minerIDs.join(","),
      vtabid: id,
    }
    return new PostRequest("/user/vtabminers/set", params);
  },
};

export const deleteTabRequest = {
  makeRequest(id: number) {
    const builder = new W2UiFilterBuilder();
    builder.setDelete(id);
    return new PostRequest("/user/vtabs/w2ui", builder.build().stringParams);
  },
};

export const renameTabRequest = {
  makeRequest(id: number, name: string) {
    const builder = new W2UiFilterBuilder();
    builder.setEdit({recid: id, name});
    return new PostRequest("/user/vtabs/w2ui", builder.build().stringParams);
  },
};
